import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import Heading from '@tds/core-heading';
import DimpleDivider from '@tds/core-dimple-divider';
import Spinner from '@tds/core-spinner';

import request from '../../utils/request';

import { ContentWrapper, Box, TopbarWrapper } from '../../design/css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { orderStatus } from '../../utils/constant';
import { getFormattedDate } from '../../utils/utils';
import useFetchContentfulData from '../../hooks/useFetchContentfulData';

import Table from './Table';
import Pagination from '../iotOrderFulfillmentDashboard/Pagination';
import SearchBar from '../iotOrderFulfillmentDashboard/components/searchBar';
import Filters from '../iotOrderFulfillmentDashboard/components/filters';

const IotSalesRepDashboard = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { noOrders }
  } = localizedStrings;
  const { data: pageLayout } = useFetchContentfulData('iotSalesRepDashboard');
  const [ordersList, setOrdersList] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [pageLoading, setPageLoading] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [filters, setFilters] = useState({
    iotProductSelected: '',
    status: '',
    flag: '',
    assignedUserId: '',
    createdBy: '',
    province: '',
    channelId: '',
    filterCriteria: '',
    startDate: '',
    endDate: ''
  });

  const {
    incomplete,
    pendingValidation,
    waitingOnCredit,
    waitingOnSales,
    contractSigned,
    contractSent,
    orderCanceled,
    contractExpired,
    orderInstalled,
    orderPlaced,
    orderActivated,
    orderShipped,
    orderCompleted
  } = orderStatus;

  const getPayload = () => {
    const payload = {
      ...filters,
      pageNumber,
      pageSize: _.get(pageLayout, 'ordersPerPage', 10),
      type: 'IOT',
      status: filters.status || [
        incomplete,
        pendingValidation,
        waitingOnCredit,
        waitingOnSales,
        contractSigned,
        contractSent,
        orderCanceled,
        contractExpired,
        orderInstalled,
        orderPlaced,
        orderActivated,
        orderShipped,
        orderCompleted
      ]
    };

    if (filters.assignedUserId)
      payload.assignedUserId = _.get(filters, 'assignedUserId.0.id');
    if (filters.createdBy) payload.createdBy = _.get(filters, 'createdBy.0.id');
    if (filters.province)
      payload.province = filters.province.map(row => row.value);
    if (filters.channelId)
      payload.channelId = filters.channelId.map(row => row.value);
    if (filters.startDate)
      payload.startDate = getFormattedDate(filters.startDate);
    if (filters.endDate) payload.endDate = getFormattedDate(filters.endDate);

    return payload;
  };

  const setOrders = data => {
    setOrdersList(_.get(data, 'data.results', []));
    setTotalOrders(_.get(data, 'data.totalCount', 0));
  };

  const fetchOrders = () => {
    setPageLoading(true);
    request
      .post('/orders/filter', getPayload())
      .then(response => {
        setOrders(response);
        setPageLoading(false);
      })
      .catch(() => {
        setPageLoading(false);
      });
  };

  useEffect(() => {
    fetchOrders();
  }, [pageNumber]);

  return (
    <>
      <DimpleDivider />
      <ContentWrapper style={{ maxWidth: '92%', margin: '0 auto', padding: 0 }}>
        <Box>
          <Filters
            setOrders={setOrders}
            filters={filters}
            setFilters={setFilters}
            getPayload={getPayload}
            includeIncompleteStatus
          />
          <DimpleDivider />
          <SearchBar setOrders={setOrders} fetchOrders={fetchOrders} />
          <>
            {pageLoading ? (
              <Spinner spinning label="Loading Orders..." />
            ) : (
              <>
                {!pageLoading && ordersList.length === 0 ? (
                  <Heading level="h3">{noOrders}</Heading>
                ) : (
                  <div>
                    <TopbarWrapper style={{ color: '#fff', fontWeight: '900' }}>
                      {`${_.get(
                        pageLayout,
                        'tableTitle',
                        ''
                      )} (${totalOrders})`}
                    </TopbarWrapper>
                    <Table
                      pageLayout={pageLayout}
                      data={ordersList}
                      fetchOrders={fetchOrders}
                    />
                    <DimpleDivider />
                    <Pagination
                      ordersPerPage={_.get(pageLayout, 'ordersPerPage', 10)}
                      totalOrders={totalOrders}
                      pageNumber={pageNumber}
                      setPageNumber={setPageNumber}
                    />
                  </div>
                )}
              </>
            )}
          </>
        </Box>
      </ContentWrapper>
    </>
  );
};

export default IotSalesRepDashboard;
